import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

function About() {
  const { t } = useTranslation();

  return (
    <section
      id="about"
      className="min-h-screen relative overflow-hidden bg-arcade-bg crt-scanlines flex items-center"
    >
      {/* faint grid */}
      <div className="absolute inset-0 bg-grid-pattern bg-grid opacity-[0.06] pointer-events-none"></div>

      {/* decorative pixels */}
      <div className="absolute top-[14%] right-[10%] w-3 h-3 bg-arcade-cyan"></div>
      <div className="absolute bottom-[16%] left-[6%] w-2.5 h-2.5 bg-arcade-yellow"></div>
      <div className="absolute top-[70%] right-[20%] w-2 h-2 bg-arcade-pink"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 py-16 md:py-20 w-full">
        {/* section header */}
        <motion.div
          className="flex items-center gap-6 mb-12 md:mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-pixel text-arcade-yellow text-lg md:text-2xl whitespace-nowrap">
            {t('about.title').toUpperCase()}
          </h2>
          <div className="h-[2px] flex-1 bg-gradient-to-r from-arcade-yellow to-arcade-yellow/0"></div>
        </motion.div>

        {/* dialog box */}
        <motion.div
          className="relative"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.15 }}
        >
          <span className="absolute -top-4 left-6 font-pixel text-[10px] md:text-xs text-arcade-bg bg-arcade-cyan px-4 py-2 z-10">
            PLAYER LOG
          </span>
          <div className="border-2 border-arcade-cyan rounded-lg bg-arcade-panel/60 shadow-[0_0_18px_rgba(77,232,244,0.25)] px-6 md:px-10 py-10 md:py-12">
            <p className="font-mono text-sm md:text-lg text-gray-200 leading-8 md:leading-9">
              {t('about.description')}
              <span className="inline-block w-2.5 h-4 md:h-5 bg-arcade-cyan ml-2 align-middle animate-pulse"></span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default About;
